
export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'Free Shipping',
      description: 'On orders over ₦30,000'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Easy Returns',
      description: '3-day return policy'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure Payment',
      description: '100% secure checkout'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Dedicated support team'
    }
  ];

  return (
    <section className="py-12 border-t border-gray-100">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {features.map((feature, index) => (
          <div key={index} className="text-center">
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-[#FDF2F6]">
              <i className={`${feature.icon} text-2xl text-[#EF579A]`}></i>
            </div>
            <h3 className="font-['Poppins'] font-semibold text-gray-800 text-sm mb-1">{feature.title}</h3>
            <p className="font-['Poppins'] text-gray-500 text-xs">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
